import { Tooltip, theme as antdTheme } from 'antd';
import { space } from '@viq-admin/ui';
import type { RepeatScanHistoryEntry, RepeatScanMatch } from './types';

interface Props {
  match: RepeatScanMatch;
  history: RepeatScanHistoryEntry[];
}

/**
 * Inline ↻ badge for the Preview cell. Renders nothing when there's no match.
 * Ported verbatim from the portal; color driven by an antd theme token instead
 * of the portal's hardcoded gray.
 */
export function RepeatScanBadge({ match, history }: Props) {
  const { token } = antdTheme.useToken();
  if (!match) return null;

  let title: string;
  if (match === 'email') {
    const list = history
      .slice(0, 3)
      .map((h) => `${h.event_name} on ${h.date}`)
      .join(', ');
    const overflow = history.length > 3 ? `, +${history.length - 3} more` : '';
    title = list
      ? `Previously scanned at ${list}${overflow}`
      : 'Previously scanned (history unavailable)';
  } else {
    title = 'Possible repeat scan: same name and company';
  }

  return (
    <Tooltip title={title} placement="top">
      <span
        aria-label="Repeat scan"
        data-match={match}
        style={{
          marginLeft: space.sm,
          color: token.colorTextTertiary,
          cursor: 'help',
          fontSize: 12,
          userSelect: 'none',
        }}
      >
        ↻
      </span>
    </Tooltip>
  );
}
